<template>
  <div role="button" class="heroslidelink heroslidelink_popform" :class="{'heroslidelink_hidden':!enabled, 'heroslidelink_popform-white':white}">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect width="32" height="32" rx="16"/>
      <path d="M18 10L12.7071 15.2929C12.3166 15.6834 12.3166 16.3166 12.7071 16.7071L18 22" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span>Вернуться</span>
  </div>
</template>

<script>
  export default {
    props: {
      white: {type: Boolean, default: false},
      enabled: {type: Boolean, default: true}
    }  
  }
</script>

<style lang="sass" scoped>
.heroslidelink.heroslidelink_popform
  position: relative
  z-index: 3
  cursor: pointer
  margin-top: 43px
  margin-bottom: 0
  transition: opacity .3s ease-out
  display: inline-flex
  font-size: 14px
  line-height: 1.12
  @include for-mob
    margin-top: 17px
    span
      display: none
    svg
      rect
        fill: none !important
  svg
    display: block
    margin-top: -1px
    margin-right: 16px
    path
      transition: transform .1s linear
      stroke: colors.$newgray
    rect
      fill: #F6F8FA
  &.heroslidelink_popform-white
    svg
      rect
        fill: #FFFFFF
  &::before
    display: none
  
  &:hover, &:active
    svg path
      transform: translateX(-1.5px)

.heroslidelink.heroslidelink_hidden
  opacity: 0
  pointer-events: none
</style>